import { PropsWithChildren } from 'react';
import { useUserFlags } from '~/hooks';
import { PageLayout } from '~/layouts';
import { CookieBanner } from '../CookieBanner';
import { Footer } from '../Footer';
import { Header } from '../Header';

export const Layout = ({ children }: PropsWithChildren) => {
    const { getFlag } = useUserFlags();
    const isMobileApp = getFlag('isMobileApp');
    return (
        <>
            {!isMobileApp && <Header />}
            <PageLayout>{children}</PageLayout>
            {!isMobileApp && (
                <>
                    <Footer />
                    <CookieBanner />
                </>
            )}
        </>
    );
};
